(function () {
  if (window.__sdCartInit) return;
  window.__sdCartInit = true;

  var KEY = 'soardist_saved_for_later';
  function readSaved() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function writeSaved(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  /* Some apps (e.g. Shopacado pricing) wrap window.fetch and resolve a non-Response
     (e.g. `true`) for /cart/change.js. Fall back to the fresh cart in that case. */
  function isResponse(r) { return !!r && typeof r.json === 'function'; }
  function freshCart() { return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }); }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (r) {
        if (!isResponse(r)) return freshCart();
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; });
      });
  }
  /* Resolve the CURRENT cart line before changing it. Line-item keys change whenever
     properties change (e.g. artwork approval or another tab), so the key rendered on
     the page can go stale -> Shopify "no valid id or line parameter". */
  function changeLine(d, props) {
    return freshCart()
      .then(function (cart) {
        var items = cart.items || [], idx = -1, i;
        for (i = 0; i < items.length; i++) { if (items[i].key === d.key) { idx = i; break; } }
        if (idx < 0 && items[d.line - 1] && items[d.line - 1].variant_id === d.id) idx = d.line - 1;
        if (idx < 0) {
          var same = items.filter(function (it) { return it.variant_id === d.id; });
          if (same.length === 1) idx = items.indexOf(same[0]);
        }
        if (idx < 0) throw new Error('This cart item was updated elsewhere. Please refresh the page and try again.');
        /* apply only what this editor changed on top of the line's current properties */
        var merged = Object.assign({}, normProps(items[idx].properties)), orig = d.properties || {}, k;
        for (k in props) { if (props[k] !== orig[k]) merged[k] = props[k]; }
        for (k in orig) { if (!(k in props)) delete merged[k]; }
        return post('/cart/change.js', { line: idx + 1, quantity: items[idx].quantity, properties: merged });
      });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function busy(btn) { if (btn) { btn.disabled = true; btn.style.opacity = '.5'; } }
  function normProps(p) {
    if (Array.isArray(p)) {
      var o = {};
      p.forEach(function (kv) { if (Array.isArray(kv) && kv.length >= 2) o[kv[0]] = kv[1]; });
      return o;
    }
    return p && typeof p === 'object' ? p : {};
  }
  function lineData(line) {
    var el = document.querySelector('[data-sd-line="' + line + '"]');
    if (!el) return null;
    var props = {};
    try { props = normProps(JSON.parse(el.dataset.sdProps || '{}')); } catch (e) {}
    return {
      line: Number(line), key: el.dataset.sdKey,
      id: Number(el.dataset.sdVariant), quantity: Number(el.dataset.sdQty) || 1, properties: props,
      title: el.dataset.sdTitle, variant_title: el.dataset.sdVariantTitle, url: el.dataset.sdUrl,
      image: el.dataset.sdImg, price: el.dataset.sdPrice, saved_at: Date.now()
    };
  }

  /* ---------- Saved for later ---------- */
  function renderSaved() {
    var wrap = document.getElementById('sd-saved');
    var list = document.getElementById('sd-saved-list');
    if (!wrap || !list) return;
    var saved = readSaved();
    wrap.hidden = saved.length === 0;
    list.innerHTML = saved.map(function (s, i) {
      var sp = normProps(s.properties);
      var job = sp['Job Name/PO#'] ? ' · Job: ' + esc(sp['Job Name/PO#']) : '';
      return '<div class="sd-saved__row">' +
        (s.image ? '<img src="' + esc(s.image) + '" alt="">' : '') +
        '<div class="sd-saved__info"><strong>' + esc(s.title) + '</strong>' + esc(s.variant_title) + job + ' · Qty ' + esc(s.quantity) + ' · ' + esc(s.price) + '</div>' +
        '<button type="button" class="sd-link" data-sd-restore="' + i + '">Move to Cart</button>' +
        '<button type="button" class="sd-link" data-sd-forget="' + i + '">Remove</button></div>';
    }).join('');
  }

  /* ---------- Shipping editor ---------- */
  var US_STATES = { AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',DC:'District of Columbia',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming' };
  var shipState = { data: null, rates: [] };

  function modalEl() {
    var m = document.getElementById('sd-ship-modal');
    if (m) return m;
    var opts = Object.keys(US_STATES).map(function (k) { return '<option value="' + k + '">' + k + ' – ' + US_STATES[k] + '</option>'; }).join('');
    m = document.createElement('div');
    m.id = 'sd-ship-modal';
    m.className = 'sd-modal';
    m.hidden = true;
    m.innerHTML =
      '<div class="sd-modal__box" role="dialog" aria-modal="true" aria-labelledby="sd-ship-title">' +
        '<h2 class="sd-modal__title" id="sd-ship-title">Edit Shipping<button type="button" class="sd-modal__close" data-sd-ship-close aria-label="Close">×</button></h2>' +
        '<div class="sd-modal__types">' +
          '<label><input type="radio" name="sd-ship-type" value="Blind Drop Ship"> Blind Drop Ship</label>' +
          '<label><input type="radio" name="sd-ship-type" value="Ship To Me"> Ship to my address</label>' +
        '</div>' +
        '<label for="sd-ship-name">Company / Attention</label><input type="text" id="sd-ship-name">' +
        '<label for="sd-ship-street">Street Address</label><input type="text" id="sd-ship-street">' +
        '<div class="sd-modal__row">' +
          '<div><label for="sd-ship-city">City</label><input type="text" id="sd-ship-city"></div>' +
          '<div><label for="sd-ship-state">State</label><select id="sd-ship-state">' + opts + '</select></div>' +
          '<div><label for="sd-ship-zip">ZIP</label><input type="text" id="sd-ship-zip" inputmode="numeric"></div>' +
        '</div>' +
        '<div id="sd-ship-from-wrap"><label for="sd-ship-from">Ship From (shown on blind label)</label><input type="text" id="sd-ship-from"></div>' +
        '<div class="sd-modal__actions" style="justify-content:flex-start"><button type="button" class="sd-btn" data-sd-ship-rates>Get Shipping Rates</button></div>' +
        '<div class="sd-rates" id="sd-ship-rates"></div>' +
        '<div class="sd-modal__msg" id="sd-ship-msg"></div>' +
        '<div class="sd-modal__actions">' +
          '<button type="button" class="sd-btn" data-sd-ship-close>Cancel</button>' +
          '<button type="button" class="sd-btn sd-btn--primary" data-sd-ship-save disabled>Save Shipping</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) { if (e.target === m) closeShip(); });
    m.addEventListener('change', function (e) {
      if (e.target.name === 'sd-ship-type') toggleFrom();
      if (e.target.name === 'sd-ship-rate') document.querySelector('[data-sd-ship-save]').disabled = false;
      if (/sd-ship-(state|zip)/.test(e.target.id)) clearRates();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) closeShip(); });
    return m;
  }
  function $(id) { return document.getElementById(id); }
  function msg(t, err) { var el = $('sd-ship-msg'); el.textContent = t || ''; el.className = 'sd-modal__msg' + (err ? ' sd-modal__msg--err' : ''); }
  function toggleFrom() {
    var t = document.querySelector('input[name=sd-ship-type]:checked');
    $('sd-ship-from-wrap').hidden = !(t && t.value === 'Blind Drop Ship');
  }
  function clearRates() { shipState.rates = []; $('sd-ship-rates').innerHTML = ''; document.querySelector('[data-sd-ship-save]').disabled = true; }

  function parseAddr(str) {
    var parts = String(str || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var r = { name: parts[0] || '', street: parts[1] || '', city: '', state: '', zip: '' };
    var last = parts[parts.length - 1] || '';
    var m = last.match(/^([A-Za-z]{2})\s+(\d{5}(?:-\d{4})?)$/);
    if (m && parts.length >= 4) { r.state = m[1].toUpperCase(); r.zip = m[2]; r.city = parts.slice(2, -1).join(', '); }
    else if (parts.length >= 3) { r.city = parts.slice(2).join(', '); }
    return r;
  }

  function openShip(line) {
    var d = lineData(line);
    if (!d) return;
    shipState.data = d;
    var m = modalEl();
    var p = d.properties;
    var a = parseAddr(p['Ship To']);
    var type = p['Shipping Option'] === 'Blind Drop Ship' ? 'Blind Drop Ship' : 'Ship To Me';
    m.querySelector('input[name=sd-ship-type][value="' + type + '"]').checked = true;
    $('sd-ship-name').value = a.name; $('sd-ship-street').value = a.street; $('sd-ship-city').value = a.city;
    $('sd-ship-state').value = a.state || 'IL'; $('sd-ship-zip').value = a.zip;
    $('sd-ship-from').value = (p['Ship From'] || '').split(',')[0].trim();
    toggleFrom(); clearRates(); msg('');
    m.hidden = false;
    $('sd-ship-name').focus();
    if (a.zip) getRates(p['Shipping Method']);
  }
  function closeShip() { var m = $('sd-ship-modal'); if (m) m.hidden = true; }

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmtDate(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function estDelivery(rate) {
    var p = shipState.data.properties;
    var prod = parseInt(String(p['Turnaround Time'] || '').match(/\d+/) || 0, 10) || 0;
    var days = rate.delivery_days && rate.delivery_days.length ? Number(rate.delivery_days[rate.delivery_days.length - 1]) : null;
    if (days == null) return '';
    return fmtDate(addBusinessDays(addBusinessDays(new Date(), prod), days));
  }
  function money(n) { return '$' + Number(n).toFixed(2); }

  function getRates(preselect) {
    var zip = $('sd-ship-zip').value.trim(), st = $('sd-ship-state').value;
    if (!/^\d{5}(-\d{4})?$/.test(zip)) { msg('Please enter a valid 5-digit ZIP code.', true); return; }
    var q = 'shipping_address[country]=United%20States&shipping_address[province]=' + encodeURIComponent(US_STATES[st] || st) + '&shipping_address[zip]=' + encodeURIComponent(zip);
    clearRates(); msg('Getting shipping rates…');
    var btn = document.querySelector('[data-sd-ship-rates]'); btn.disabled = true;
    fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST' })
      .then(function (r) { if (isResponse(r) && !r.ok && r.status !== 202) return r.json().then(function (j) { throw new Error(Object.values(j).join(' ')); }); })
      .then(function poll(_, tries) {
        tries = tries || 0;
        return fetch('/cart/async_shipping_rates.json?' + q).then(function (r) { return isResponse(r) ? r.text() : ''; }).then(function (t) {
          if ((!t || t === 'null') && tries < 15) return new Promise(function (res) { setTimeout(res, 800); }).then(function () { return poll(null, tries + 1); });
          return t && t !== 'null' ? JSON.parse(t) : { shipping_rates: [] };
        });
      })
      .then(function (j) {
        var rates = ((j && j.shipping_rates) || []).filter(function (r) { return r.code !== 'SD_CART_QUOTED' && !/as quoted in cart/i.test(r.name || ''); });
        shipState.rates = rates;
        if (!rates.length) { msg('No shipping rates found for this address.', true); return; }
        msg('');
        $('sd-ship-rates').innerHTML = rates.map(function (r, i) {
          var eta = estDelivery(r);
          var checked = preselect && r.name === preselect ? ' checked' : '';
          return '<label class="sd-rate"><input type="radio" name="sd-ship-rate" value="' + i + '"' + checked + '>' +
            '<span>' + esc(r.presentment_name || r.name) + (eta ? '<small>Est. delivery ' + esc(eta) + '</small>' : '') + '</span>' +
            '<strong>' + (Number(r.price) === 0 ? 'FREE' : money(r.price)) + '</strong></label>';
        }).join('');
        document.querySelector('[data-sd-ship-save]').disabled = !document.querySelector('input[name=sd-ship-rate]:checked');
      })
      .catch(function (err) { msg(err.message || 'Could not get rates.', true); })
      .finally(function () { btn.disabled = false; });
  }

  function saveShip() {
    var d = shipState.data;
    var sel = document.querySelector('input[name=sd-ship-rate]:checked');
    if (!d || !sel) { msg('Please choose a shipping method.', true); return; }
    var name = $('sd-ship-name').value.trim(), street = $('sd-ship-street').value.trim(), city = $('sd-ship-city').value.trim();
    var st = $('sd-ship-state').value, zip = $('sd-ship-zip').value.trim();
    if (!name || !street || !city || !zip) { msg('Please complete the ship-to address.', true); return; }
    var type = document.querySelector('input[name=sd-ship-type]:checked').value;
    var rate = shipState.rates[Number(sel.value)];
    var props = Object.assign({}, d.properties);
    props['Shipping Option'] = type;
    props['Ship To'] = [name, street, city, st + ' ' + zip].join(', ');
    if (type === 'Blind Drop Ship') {
      var from = $('sd-ship-from').value.trim();
      if (from) props['Ship From'] = from;
    }
    props['Shipping Method'] = rate.presentment_name || rate.name;
    props['_Shipping price'] = Number(rate.price) === 0 ? 'FREE' : money(rate.price);
    props['_Shipping code'] = rate.code || '';
    var eta = estDelivery(rate);
    if (eta) props['Est. Delivery'] = eta;
    var btn = document.querySelector('[data-sd-ship-save]'); btn.disabled = true;
    msg('Saving…');
    changeLine(d, props)
      .then(function () { location.reload(); })
      .catch(function (err) { msg(err.message, true); btn.disabled = false; });
  }

  /* ---------- Job name editor ---------- */
  function editJobName(line) {
    var box = document.querySelector('[data-sd-jobname="' + line + '"]');
    var d = lineData(line);
    if (!box || !d || box.querySelector('input')) return;
    var current = d.properties['Job Name/PO#'] || '';
    box.dataset.sdOrig = box.innerHTML;
    box.innerHTML = '<span class="sd-job__label">Job Name:</span>' +
      '<input type="text" maxlength="60" aria-label="Job name" value="' + esc(current).replace(/"/g, '&quot;') + '">' +
      '<button type="button" class="sd-btn sd-btn--primary" data-sd-jobname-save="' + line + '">Save</button>' +
      '<button type="button" class="sd-btn" data-sd-jobname-cancel="' + line + '">Cancel</button>';
    var input = box.querySelector('input');
    input.focus(); input.select();
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); saveJobName(line); }
      if (e.key === 'Escape') { e.preventDefault(); cancelJobName(line); }
    });
  }
  function cancelJobName(line) {
    var box = document.querySelector('[data-sd-jobname="' + line + '"]');
    if (box && box.dataset.sdOrig) box.innerHTML = box.dataset.sdOrig;
  }
  function saveJobName(line) {
    var box = document.querySelector('[data-sd-jobname="' + line + '"]');
    var d = lineData(line);
    if (!box || !d) return;
    var input = box.querySelector('input');
    var val = input.value.trim();
    if (val === (d.properties['Job Name/PO#'] || '')) return cancelJobName(line);
    var props = Object.assign({}, d.properties);
    if (val) props['Job Name/PO#'] = val; else delete props['Job Name/PO#'];
    box.querySelectorAll('button,input').forEach(function (el) { el.disabled = true; });
    changeLine(d, props)
      .then(function () { location.reload(); })
      .catch(function (err) {
        box.querySelectorAll('button,input').forEach(function (el) { el.disabled = false; });
        var e = box.querySelector('.sd-jobname__err') || box.appendChild(document.createElement('div'));
        e.className = 'sd-jobname__err'; e.textContent = err.message;
      });
  }

  /* ---------- Click handling ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sd-empty-cart],[data-sd-save],[data-sd-duplicate],[data-sd-restore],[data-sd-forget],[data-sd-ship],[data-sd-ship-close],[data-sd-ship-rates],[data-sd-ship-save],[data-sd-jobname-edit],[data-sd-jobname-save],[data-sd-jobname-cancel]');
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-sd-jobname-edit')) return editJobName(t.getAttribute('data-sd-jobname-edit'));
    if (t.hasAttribute('data-sd-jobname-save')) return saveJobName(t.getAttribute('data-sd-jobname-save'));
    if (t.hasAttribute('data-sd-jobname-cancel')) return cancelJobName(t.getAttribute('data-sd-jobname-cancel'));
    if (t.hasAttribute('data-sd-ship')) return openShip(t.getAttribute('data-sd-ship'));
    if (t.hasAttribute('data-sd-ship-close')) return closeShip();
    if (t.hasAttribute('data-sd-ship-rates')) return getRates();
    if (t.hasAttribute('data-sd-ship-save')) return saveShip();
    if (t.hasAttribute('data-sd-empty-cart')) {
      if (!confirm('Remove all jobs from your cart?')) return;
      busy(t);
      post('/cart/clear.js').then(function () { location.reload(); });
    } else if (t.hasAttribute('data-sd-save')) {
      var d = lineData(t.getAttribute('data-sd-save'));
      if (!d) return;
      busy(t);
      var saved = readSaved(); saved.push(d); writeSaved(saved);
      post('/cart/change.js', { line: d.line, quantity: 0 })
        .then(function () { location.reload(); })
        .catch(function (err) { alert(err.message); location.reload(); });
    } else if (t.hasAttribute('data-sd-duplicate')) {
      var dd = lineData(t.getAttribute('data-sd-duplicate'));
      if (!dd) return;
      busy(t);
      post('/cart/add.js', { items: [{ id: dd.id, quantity: dd.quantity, properties: dd.properties }] })
        .then(function () { location.reload(); })
        .catch(function (err) { alert(err.message); location.reload(); });
    } else if (t.hasAttribute('data-sd-restore')) {
      var list = readSaved(); var i = Number(t.getAttribute('data-sd-restore')); var s = list[i];
      if (!s) return;
      busy(t);
      post('/cart/add.js', { items: [{ id: s.id, quantity: s.quantity, properties: normProps(s.properties) }] })
        .then(function () { list.splice(i, 1); writeSaved(list); location.reload(); })
        .catch(function (err) { alert(err.message); renderSaved(); });
    } else if (t.hasAttribute('data-sd-forget')) {
      var l2 = readSaved(); l2.splice(Number(t.getAttribute('data-sd-forget')), 1); writeSaved(l2); renderSaved();
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderSaved); else renderSaved();
})();
